/* SSL Shade Finder — client-side filter + render. */
(function () {
  const root = document.querySelector('.ssl-shade-finder');
  if (!root) return;

  const dataEl = document.getElementById('ssl-shade-finder-data');
  let data = { products: [] };
  try { data = JSON.parse(dataEl.textContent); } catch {}

  const submit = root.querySelector('[data-ssl-shade-submit]');
  const results = root.querySelector('[data-ssl-shade-results]');
  const depthOut = root.querySelector('[data-ssl-depth-out]');

  // Optional analyzer→shade-finder undertone hand-off.
  try {
    const stored = localStorage.getItem('ssl-undertone');
    if (stored) {
      const radio = root.querySelector(`input[name=undertone][value="${stored}"]`);
      if (radio) {
        radio.checked = true;
        // Trigger the progressive-reveal listener below.
        root.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  } catch {}

  // Progressive reveal: show next step when current is satisfied.
  root.addEventListener('change', () => {
    const undertone = root.querySelector('input[name=undertone]:checked');
    const depthStep = root.querySelector('[data-step=depth]');
    const categoryStep = root.querySelector('[data-step=category]');
    if (undertone) depthStep.hidden = false;
    const depth = root.querySelector('input[name=depth]');
    if (depth) depthOut.textContent = depth.value;
    if (undertone) categoryStep.hidden = false;
  });

  submit.addEventListener('click', () => {
    const undertone = root.querySelector('input[name=undertone]:checked')?.value;
    const depth = Number(root.querySelector('input[name=depth]').value || 5);
    const cats = [...root.querySelectorAll('input[name=category]:checked')].map(i => i.value);
    if (!undertone || cats.length === 0) {
      results.hidden = false;
      results.innerHTML = '<p>Pick an undertone and at least one category.</p>';
      return;
    }
    const matches = filterShades({ undertone, depth, cats });
    renderResults(matches);
  });

  function filterShades({ undertone, depth, cats }) {
    const out = [];
    for (const p of data.products) {
      // Category match: product_type substring (e.g. 'lip-tint' matches 'lip').
      const productCat = (p.category || '').toLowerCase();
      if (!cats.some(c => productCat.includes(c))) continue;
      for (const v of (p.variants || [])) {
        if (!v.available) continue;
        // Undertone: exact OR neutral wildcard. Empty undertone passes.
        if (v.undertone && v.undertone !== undertone && v.undertone !== 'neutral') continue;
        // Depth: ±1. depth_level=0 is "unset" → pass.
        if (v.depth_level && Math.abs(v.depth_level - depth) > 1) continue;
        out.push({
          handle: p.handle,
          title: p.title,
          url: `${p.url}?variant=${v.id}`,
          image: p.image,
          vendor: p.vendor,
          variant: v,
          depthDelta: v.depth_level ? Math.abs(v.depth_level - depth) : 99,
        });
      }
    }
    out.sort((a, b) => a.depthDelta - b.depthDelta);
    return out;
  }

  function renderResults(items) {
    results.hidden = false;
    results.innerHTML = '';
    if (items.length === 0) {
      results.innerHTML = '<p data-ssl-empty>No exact matches yet. Try widening depth or undertone.</p>';
      return;
    }
    for (const m of items) {
      const a = document.createElement('a');
      a.className = 'ssl-shade-card';
      a.href = m.url;
      a.innerHTML = `
        ${m.image ? `<div class="ssl-shade-card__img" style="background-image:url('${m.image}')"></div>` : '<div class="ssl-shade-card__img-placeholder"></div>'}
        <p class="ssl-type-eyebrow">${escapeHtml(m.vendor)}</p>
        <h3 class="ssl-type-serif">${escapeHtml(m.title)}</h3>
        <p>${escapeHtml(m.variant.title)}</p>
        ${m.variant.swatch_color ? `<span class="ssl-shade-card__dot" style="background:${m.variant.swatch_color}"></span>` : ''}
      `;
      results.appendChild(a);
    }
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
  }
})();
